import UserRequests from '../../../utils/requests/user';
export default {
    data() {
        return {
            editDialog: {
                show: false,
                error: null,
                currentUser: {}
            }
        };
    },

    methods: {
        editUser(user) {
            this.editDialog.currentUser = user;
            this.editDialog.error = false;
            this.editDialog.show = true;
        },

        async updateUser(userId, payload) {
            try {
                await UserRequests.updateUser(userId, payload);
                this.reloadUser(userId);
                this.editDialog.show = false;
            } catch (error) {
                this.editDialog.error = error?.response?.data?.message || null;
            }
        }
    }
};
